module.exports = __webpack_public_path__ + "img/burned_teens_old.3e15d328.jpg";